import { render, staticRenderFns } from "./PortfolioRisk.vue?vue&type=template&id=a045946a&scoped=true&"
import script from "./PortfolioRisk.vue?vue&type=script&lang=js&"
export * from "./PortfolioRisk.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioRisk.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PortfolioRisk.vue?vue&type=style&index=1&id=a045946a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a045946a",
  null
  
)

component.options.__file = "packages/cb-components-portfolio/src/components/main/PortfolioRisk.vue"
export default component.exports